export default __webpack_public_path__ + "static/oapostolo-4cc85d85aa8fad2ffdf4761ffd393b5b.jpg";